import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';

const navItems = [
  { label: 'Dashboard', icon: '📊', path: '/' },
  { section: 'Students' },
  { label: 'Students', icon: '🎓', path: '/students' },
  { label: 'Add Student', icon: '➕', path: '/students/add' },
  { section: 'Finance' },
  { label: 'Fees', icon: '💰', path: '/fees' },
  { section: 'Rooms' },
  { label: 'Room Management', icon: '🏠', path: '/rooms' },
  { section: 'Staff' },
  { label: 'Staff', icon: '👥', path: '/staff' },
  { label: 'Attendance', icon: '📋', path: '/attendance' },
  { label: 'Salaries', icon: '💵', path: '/salaries' },
  { section: 'Expenses' },
  { label: 'Utility Bills', icon: '⚡', path: '/bills' },
  { label: 'Maintenance', icon: '🔧', path: '/maintenance' },
  { section: 'Reports' },
  { label: 'Monthly Report', icon: '📈', path: '/reports' },
];

export default function Layout({ children, title }) {
  const { username, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <Logo size={45} />
          <div className="sidebar-logo-text">
            <h2>Royal Tower</h2>
            <p>Hostel Management</p>
          </div>
        </div>
        <nav className="sidebar-nav">
          {navItems.map((item, i) =>
            item.section ? (
              <div key={i} className="nav-section-title">{item.section}</div>
            ) : (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              >
                <span className="nav-icon">{item.icon}</span>
                {item.label}
              </NavLink>
            )
          )}
        </nav>
      </aside>

      <div className="main-content">
        <header className="topbar">
          <h1 className="topbar-title">{title}</h1>
          <div className="topbar-right">
            <span className="admin-badge">👤 {username}</span>
            <button className="logout-btn" onClick={handleLogout}>Logout</button>
          </div>
        </header>
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}
